import { RichContentWithTooltip } from '../../components/RichContent';
import { WizardLayoutFormWithCommonSection } from '../../components/WizardLayoutForm';

import type { HardDeclineProps } from './types';
import type { FC } from 'react';

export const HardDecline: FC<HardDeclineProps> = ({ content, previousButtonCopy, eventHandlers }) => {
  return (
    <WizardLayoutFormWithCommonSection
      backCopy={previousButtonCopy}
      onBack={eventHandlers.onBack}
      isForwardHidden={true}
    >
      <RichContentWithTooltip content={content} />
    </WizardLayoutFormWithCommonSection>
  );
};
